export default __webpack_public_path__ + "static/media/geeni-alert-circle.54134dc0.svg";